export default function () {
    let currentPage = 1;

    $(document).on('click', '.products__btn-lazy-load', function () {
        const totalCount = $(this).attr('data-pages-count');
        let url = new URL(window.location);
        let searchParams = url.searchParams;
        searchParams.set('page', currentPage + 1);
        url.search = searchParams.toString();

        $.get(url, function (html) {
            let $html = $(html);
            let $items = $html.find('.products__items').children().children();
            $('.products__items').children().append($items);
            $(document).trigger('update_products');
            currentPage++;
            $('.products__pagination').replaceWith($html.find('.products__pagination'));

            if (currentPage >= totalCount) {
                $('.products__btn-lazy-wrap').hide();
            }
        });
    });

    $(document).on('update_products', function () {
        const $productsBlock = $('.js-products');

        Update($productsBlock);
    });
}


